import { useState, useRef } from "react";
import { accessAPI, Formulario } from "../../../shared";
import { Toast } from "primereact/toast";

export default function FormularioNuevoCliente({ onClienteCreado }) {
  const [formLoader, setFormLoader] = useState(false);
  const toast = useRef(null);

  function crearClienteSubmit(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/cliente",
      camposFormulario,
      (respuesta) => {
        setFormLoader(false);
        if (onClienteCreado) onClienteCreado(respuesta[0]);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0].msg,
          sticky: true
        });
      }
    );
  }

  const formConfig = {
    secciones: [
      {
        nombre: "Datos de la empresa",
        campos: [
          {
            nombre: "razonsocial",
            tipoitemformularioid: 1,
            etiqueta: "Razón social",
            requerido: true
          },
          {
            nombre: "nombrefantasia",
            tipoitemformularioid: 1,
            etiqueta: "Nombre fantasía"
          },
          {
            nombre: "rut",
            tipoitemformularioid: 1,
            etiqueta: "Identificador"
          },
          {
            nombre: "tipoIdentificadorId",
            tipoitemformularioid: 5,
            etiqueta: "Tipo",
            opciones: "admin/config/tipoidentificador?dropdown=true",
            sinOpcionInicial: true
          },
          {
            nombre: "direccion",
            tipoitemformularioid: 1,
            etiqueta: "Dirección",
            requerido: true
          },
          {
            nombre: "codigopostal",
            tipoitemformularioid: 1,
            etiqueta: "Código postal"
          },
          {
            nombre: "ciudad",
            tipoitemformularioid: 1,
            etiqueta: "Ciudad",
            requerido: true,
            respuesta: "Montevideo"
          },
          {
            nombre: "estado",
            tipoitemformularioid: 1,
            etiqueta: "Estado",
            requerido: true,
            respuesta: "Montevideo"
          },
          {
            nombre: "pais",
            tipoitemformularioid: 1,
            etiqueta: "País",
            requerido: true,
            respuesta: "Uruguay"
          },
          {
            nombre: "telefono",
            tipoitemformularioid: 1,
            etiqueta: "Teléfono"
          },
          {
            nombre: "pagina",
            tipoitemformularioid: 1,
            etiqueta: "Página"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear cliente",
        callback: crearClienteSubmit,
        validar: true
      }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Formulario config={formConfig} loader={formLoader} />
    </>
  );
}
